import { FormGroup } from '@angular/forms';
import { FieldDeselector } from '../../models/field-deselector';
import { FormGroupType } from '../../models/form-group-type';
import { Observable, takeUntil } from 'rxjs';
import { Injectable } from '@angular/core';

/**
 * Service to reset/clear the values on dependent fields when a field value changes on a form.
 */
@Injectable({
    providedIn: 'root',
})
export class FormControlService {
    /**
     * Summary: Method to reset/clear the values on dependent fields when a field value changes on a form.
     * @param form
     * @param dependentFormControlsForReset form controls that will be reset when parent form control value changes
     * @param destroy$ subject that tracks the lifecycle of the component where the form controls are used
     */
    setupFormDeselectorsHandler<TFormModel>(
        form: FormGroup<FormGroupType<TFormModel>>,
        dependentFormControlsForReset: FieldDeselector<TFormModel>,
        destroy$: Observable<void>,
    ) {
        for (const key in dependentFormControlsForReset) {
            form
                .get(key)
                ?.valueChanges.pipe(takeUntil(destroy$))
                .subscribe(() => {
                    dependentFormControlsForReset[key]?.dependentFields.forEach(
                        (dependentField) => {
                            form.controls[dependentField]?.reset();
                        },
                    );
                });
        }
    }
}
